<template>
  <section class="section">
    <div class="container">
      <div data-aos="fade-up">
        <span class="section-eyebrow">CODE</span>
        <h2 class="section-title">代码演示</h2>
        <p class="section-subtitle">{{ subtitle || '真实可用的代码示例，复制即用' }}</p>
      </div>

      <div class="code-tabs" data-aos="fade-up" data-aos-delay="80">
        <button
          v-for="(b, i) in tabs"
          :key="b.key"
          class="code-tab"
          :class="{ active: active === b.key }"
          @click="active = b.key"
        >
          <i :class="b.icon"></i> {{ b.label }}
        </button>
      </div>

      <div v-if="activeBlock" class="code-show" data-aos="fade-up">
        <CodeBlock :code="activeBlock.code" :lang="activeBlock.lang" :title="activeBlock.title" />
      </div>

      <!-- 引用方式 -->
      <div v-if="gradleBlock" class="install-block" data-aos="fade-up">
        <h3 class="install-title"><i class="fa-solid fa-download"></i> 引用方式</h3>
        <CodeBlock :code="gradleBlock" lang="gradle" title="build.gradle — dependencies" />
        <div v-if="mavenBlock" class="install-extra">
          <p class="install-note"><i class="fa-solid fa-circle-info"></i> 如果引用失败，可加入备用仓库：</p>
          <CodeBlock :code="mavenBlock" lang="gradle" title="build.gradle — repositories" />
        </div>
        <div v-if="proguardBlock" class="install-extra">
          <p class="install-note"><i class="fa-solid fa-shield-halved"></i> 代码混淆配置：</p>
          <CodeBlock :code="proguardBlock" lang="gradle" title="proguard-rules.pro" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import CodeBlock from '@/components/CodeBlock.vue'

const props = defineProps({
  codeBlocks: { type: Array, default: () => [] },
  gradleBlock: { type: String, default: '' },
  mavenBlock: { type: String, default: '' },
  proguardBlock: { type: String, default: '' },
  subtitle: { type: String, default: '' }
})

const langIcons = {
  kotlin: 'fa-solid fa-fire',
  java: 'fa-brands fa-java',
  xml: 'fa-solid fa-code',
  gradle: 'fa-solid fa-gears',
  bash: 'fa-solid fa-terminal'
}

const tabs = computed(() => props.codeBlocks.map((b, i) => ({
  key: i,
  label: b.title,
  icon: langIcons[b.lang] || 'fa-solid fa-code'
})))

const active = ref(0)

const activeBlock = computed(() => props.codeBlocks[active.value] || null)
</script>

<style scoped>
.code-tabs {
  display: flex;
  gap: 6px;
  margin-top: 48px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--border-soft);
  padding-bottom: 0;
}
.code-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-size: 0.88rem;
  color: var(--text-muted);
  border-radius: 8px 8px 0 0;
  position: relative;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}
.code-tab:hover { color: var(--text); background: var(--bg-elevated); }
.code-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
  background: var(--bg-surface);
}
.code-tab i { font-size: 0.8rem; }

.install-block {
  margin-top: 48px;
  padding-top: 48px;
  border-top: 1px solid var(--border-soft);
}
.install-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.4rem;
  margin-bottom: 22px;
  color: var(--text);
}
.install-title i { color: var(--accent); }
.install-extra { margin-top: 22px; }
.install-note {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-muted);
  font-size: 0.88rem;
  margin-bottom: 12px;
}
.install-note i { color: var(--accent); }
</style>
